const init_header = require('./parts/_header');
const init_forms = require('./parts/_forms');
const init_anchor = require('./parts/_anchor');
const init_scroll_to_top = require('./parts/_scroll-to-top');
const init_login_popup = require('./parts/_login-popup');
const init_lu_filter = require('./parts/_lu-filter');
const init_true_false_descriptions = require('./parts/_true-false-descriptions');
const init_map_latlong = require('./parts/_map-latlong');
const init_page_enter_data = require('./pages/_enter-data');
const init_context_header = require('./pages/_context-header');
const init_activity1_form = require('./pages/_activity-1-form');
const init_activity1_summary = require('./pages/_activity-1-summary');
const init_activity1_date_summary = require('./pages/_activity-1-date-summary');
const init_activity1_plant = require('./pages/_activity-1-plant');
const init_activity3_form = require('./pages/_activity-3-form');
const init_activity3_summary = require('./pages/_activity-3-summary');
const init_nonsite_observations = require('./pages/_nonsite-observations');
const init_nonsite_observations_form = require('./pages/_nonsite-observations-form');

function initialize_all() {
  init_header();
  init_forms();
  init_anchor();
  init_scroll_to_top();
  init_login_popup();
  init_lu_filter(jQuery);
  init_true_false_descriptions(jQuery);
  init_map_latlong(jQuery);
  const slugs = (typeof mlmp_settings !== 'undefined') ? mlmp_settings : {};
  if (slugs.page_slug_enter_data && document.querySelector('body.body-' + slugs.page_slug_enter_data)) {
    init_page_enter_data(jQuery);
  }
  if (slugs.page_slug_activity_1 && document.querySelector('body.body-' + slugs.page_slug_activity_1)) {
    init_activity1_form(jQuery);
  }
  if (slugs.page_slug_activity_1_summary && document.querySelector('body.body-' + slugs.page_slug_activity_1_summary)) {
    init_activity1_summary(jQuery);
  }
  if (slugs.page_slug_activity_1_date_summary && document.querySelector('body.body-' + slugs.page_slug_activity_1_date_summary)) {
    init_activity1_date_summary(jQuery);
  }
  if (slugs.page_slug_activity_1_plant && document.querySelector('body.body-' + slugs.page_slug_activity_1_plant)) {
    init_activity1_plant(jQuery);
  }
  if (slugs.page_slug_activity_3 && document.querySelector('body.body-' + slugs.page_slug_activity_3)) {
    init_activity3_form(jQuery);
  }
  if ((slugs.page_slug_activity_3_summary && document.querySelector('body.body-' + slugs.page_slug_activity_3_summary)) ||
      (slugs.page_slug_nonsite_a3_summary && document.querySelector('body.body-' + slugs.page_slug_nonsite_a3_summary))) {
    init_activity3_summary(jQuery);
  }
  if (slugs.page_slug_nonsite_observations && document.querySelector('body.body-' + slugs.page_slug_nonsite_observations)) {
    init_nonsite_observations(jQuery);
  }
  if (slugs.page_slug_observations && document.querySelector('body.body-' + slugs.page_slug_observations)) {
    init_nonsite_observations_form(jQuery);
  }
  if (document.querySelector('#site-name-location, #site-name-location-year')) {
    init_context_header(jQuery);
  }

}

if (document.readyState !== 'loading') {
  initialize_all();
} else {
  document.addEventListener('DOMContentLoaded', initialize_all);
}


